import * as Common from '@/agiles/common';

//** api通信に使用するオブジェクトの基本クラス。WebAPI側と共有されるクラス名を保持します。 */
export abstract class ObjectBase {
  constructor(className: string) {
    this.className = className;
  }
  public className: string;
  public binders: { [key: string]: Common.ModelBinder } = {};
  public get binder() : Common.ModelBinder{    
    const ctor = this.constructor as new ()=>Common.ObjectBase; //キャストしないとTypeScriptの型チェックを通らない
    return new Common.ModelBinder(ctor);
  }
  public isLoaded: boolean = true;
  public lastUpdatedOn: Date;
  public eventCode :string = null;
  public copy() :any {    
    return this.binder.loadInstance(this);
  }
  public get actionTooltip():string {return null};  
  public get actionIsAlert():boolean {return true};    
  //以下のメッセージはStateObjectもしくはStateObject2を対象としており、単純なObjectBaseの場合は削除不可・編集不可にならないため表示されません。
  public get messageOnDelete():string {return 'ワークフローが進行しているため削除できません。';}
  public get messageOnEdit():string { return 'ワークフローが進行しているため編集できません。';}
  public get messageOnActionMissing():string { return '可能なワークフローアクションがありません。';}  
  public auditName:string = '';
  public auditNo: string = '';  
}
//編集前・削除前・追加後・更新後に遷移させるターゲットステータス
export enum DefaultActionFlags {edit,delete,add,update}
export abstract class StateObject extends ObjectBase {
  constructor(className: string) {
    super(className);
  }
  public state: number =1;//フラグ値を変更;  
  public workflowStateId: number = 0;
  public workflowId: number = 0;
  public workflowActionName: string = '';
  public _workflowHolder: string = null;
  public get workflowHolder():string{ return this._workflowHolder;}
  public set workflowHolder(value:string) {this._workflowHolder = value;}
  public workflowCode: string='';
  public isClosed:boolean = false;
  // public workflowHistory:string = null;
  public workflowMessage:WorkflowMessage = null;
  public emailInfo: Common.EmailInfo = null;
  public getTargetState(stateId : number, actionFlag : DefaultActionFlags){
    return 0;
  }
  // public get workflowHistories() :WorkflowHistory[]{
  //   const result = new Array<WorkflowHistory>();
  //   if (this.workflowHistory != null){
  //     (JSON.parse(this.workflowHistory) as Array<any>).forEach(source => {
  //       const target = new WorkflowHistory();
  //       Object.assign(target,source);
  //       result.push(target);
  //     });
  //   }
  //   result.reverse();//降順で表示する
  //   return result;
  // }
  public isDeletable(api: Common.Api):boolean{        
    //既定動作=>開始ステータスの場合だけ削除できる=>2020.3.3 haramoto フラグ化対応
    return (api.perms.getWorkflowState(this.workflowCode, this.workflowId, this.workflowStateId).type & Common.StateTypes.EntryStatus)  == Common.StateTypes.EntryStatus;
  }

  public copy() :any {    
    const temp = super.copy() as StateObject;    
    temp.state = 1;
    temp.workflowHolder = null;
    temp.workflowStateId = 1;
    temp.isClosed = false;
    // temp.workflowHistory = null;    
    return temp;
  }  
}

export abstract class StateObject2 extends ObjectBase {
  constructor(className: string) {
    super(className);
  }
  public state: number =1;//フラグ値を変更;  
  public auditName:string = '';
  public auditNo: string = '';
  public isClosed:boolean = false;
  public deletableStates:number[];
  public get isDeletable():boolean {
    //現在のstateがdeletableStatesに含まれている場合は削除可。
    return this.deletableStates.filter(obj =>obj == this.state).length >0;
  }
  public copy() :any {    
    const temp = super.copy() as StateObject2;    
    temp.state = 1;
    temp.isClosed = false;  
    return temp;
  }  
}

  export class WorkflowHistory extends ObjectBase
  {
      constructor() {
        super('WorkflowHistory');
      }        
      public userId :string;
      public stateId :number;
      public holder:string;
      public timeStamp : Date;
      public actionName: string;
  }

  export class WorkflowMessage extends ObjectBase
  {
      constructor() {
        super('WorkflowMessage');
      }     
      public userId :string;
      public destination :string;
      public description :string;
      public timeStamp :Date;
      public isNote :boolean;
  }

  export class WorkflowInfo extends ObjectBase
  {
    constructor() {
      super('WorkflowInfo');
      this.binders.workflowHistories = new Common.ModelBinder(WorkflowHistory,true);
      this.binders.workflowMessages = new Common.ModelBinder(WorkflowMessage,true);      
    }    
    public workflowHistories: WorkflowHistory[];
    public workflowMessages: WorkflowMessage[];
  }


// リストロード用に配置〜ModelBinderは空のコンストラクタしか受け付けないため
export class BindItem2 extends ObjectBase {
  constructor() {
    super('BindItem');
  }
  public value: any;
  public text: string;
}

export class ErrorDetails extends ObjectBase {
  constructor() {
    super('ErrorDetails');
  }
  public statusCode: number;
  public message: string;
  public get messageHtml() :string {
    return this.message.replace("\r\n","<Br>");
  }
}

export interface IMasterItem {
  name: string;
}

export interface IListProvider {
  getList(): Common.BindItem[];
}

export abstract class Query extends ObjectBase {
  constructor(className:string, responseBinder: Common.ModelBinder){
    super(className);
    this.responseBinder = responseBinder;
  }
  public responseBinder : Common.ModelBinder;
}
//ダミークエリ(フレームワークから実装クラスを呼び出す際に使用)
export class DummyQuery extends Query {
  constructor(className:string, responseBinder: Common.ModelBinder){
    super(className,responseBinder);
  }
}
/**レコード(複数)をサーバーに送信してクエリを実行し、指定した型の結果配列を受取ります。 */
export abstract class ExecuteQuery extends Query {
  constructor(className:string, responseType: new () => ObjectBase){
    super(className,new Common.ModelBinder(responseType,true));
  }
  public items: any[];
}

export abstract class LoadQuery extends Query {
  constructor(className:string, ctor: new () => ObjectBase){
    super(className,new Common.GenericModelBinder(LoadResult, ctor));
  }
  public currentPage: number = 1;
  public perPage: number = 10;
  public sort: string = '';
  public search: string = '';
  public isDescending = false;
  public loadAll = false; //明細タブで使用
  public countOnly:boolean = false;
  //選択項目のエクスポート用
  public exportedItems: any[] = null;
}

export class LoadResult extends ObjectBase  {
  constructor(ctor: new()=>ObjectBase){
    super('LoadResult');
    this.binders.result = new Common.ModelBinder(ctor);
  }
  public records: number = 0;
  public result: any[] = new Array();
}

export class CountQuery extends Query {
  constructor(jsons : any[], className : string){
    super("CountQuery!" +className,null); //ジェネリック型としてサーバーに転送。レスポンスバインダは不要
    this.queries = jsons;
  }  
  public queries : any[];

}
export class WorkflowInfoQuery extends Query {
  constructor(auditName:string, auditNo:string) {
    super('WorkflowInfoQuery', new Common.ModelBinder(WorkflowInfo,false))
    this.auditName = auditName;
    this.auditNo = auditNo;
  }
  public auditName: string ;
  public auditNo:string;
}
export class ExportQuery extends Query {
  constructor(sheetName:string, loadQuery:LoadQuery){
    super("ExportQuery!" + loadQuery.className,null); //ジェネリック型としてサーバーに転送。レスポンスバインダは不要
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
  }
  public loadQuery : LoadQuery;
  public sheetName  :string;
  public fileLayoutId:number= null;
}

export class ImportQuery extends Query{
    constructor(sheetName:string, className:string){
    super("ImportQuery!" + className,null); //ジェネリック型としてサーバーに転送。レスポンスバインダは不要
    this.sheetName = sheetName;
  }
  public sheetName  :string;
  public userSheetName :string;
  public fileLayoutId:number= null;  
  public isBeforeUnPost:boolean=false;
  public isAfterPost:boolean=false;
}

/**ライセンスフラグ値を取得します。 */
export class LicenseQuery extends Query {
  constructor(){
    super('LicenseQuery',new Common.ModelBinder(LicenseResult,false)); 
  }
}

/**パートナーかどうかを取得します */
export class isPartnerQuery extends Query {
  constructor(){
    super('isPartnerQuery',null); 
  }
}

export class ConversionFlagUpdateQuery extends Query {
  constructor(conversionFlag: Common.conversionFlags){
    super('ConversionFlagUpdateQuery',new Common.ModelBinder(LicenseResult,false)); 
    this.conversionFlag = conversionFlag;
  }
  public conversionFlag : Common.conversionFlags;
}
export enum conversionFlags{None, BounceBack,OneDay,OneWeek, TwoWeek,ThreeWeek,FourWeek,Paid}

export class ListResult extends ObjectBase {
    constructor(){
      super('ListResult');
      this.binders.items = new Common.ModelBinder(BindItem2,true);
    }
    public listName : string;
    public items: Common.BindItem[];
}

export class ListQuery extends Query {
  constructor(){
    super("ListQuery",new Common.ModelBinder(ListResult,true));
  }
  public list : Array<string> = new Array();
  public ajaxList: { [listName: string]: any[]} = {};
}

export class LicenseResult extends ObjectBase {
    constructor(){
      super('LicenseResult');
      this.binders.user = new Common.ModelBinder(Common.User,false);
      this.binders.permissions = new Common.ModelBinder(Common.Permission,true);
      this.binders.workflowActions = new Common.ModelBinder(Common.WorkflowAction,true);
      this.binders.workflowPermissions = new Common.ModelBinder(Common.WorkflowPermission,true);
      this.binders.workflowControllers = new Common.ModelBinder(Common.WorkflowController,true);
      this.binders.groups = new Common.ModelBinder(Common.GroupMember,true);
      this.binders.proxyUsers = new Common.ModelBinder(Common.User,true);           
      this.binders.urlPermissions = new Common.ModelBinder(Common.BindItem2,true)  ;
    }
  public user : Common.User;
  public permissions : Common.Permission[];
  public workflowActions : Common.WorkflowAction[];
  public workflowPermissions : Common.WorkflowPermission[];
  public workflowControllers : Common.WorkflowController[];
  public groups :Common.GroupMember[];
  public proxyUsers: Common.User[];
  public licenseFlag : number;  
  public optionFlag : number;  
  public tenantId:string;
  public tenantName:string;
  public tenantVersion:Common.TenantVersions;
  public functionFlag:number;
  public loginName : string;  
  public isTrial : boolean;
  // クライアント側で更新を見込むためuserとは別で定義
  public countOnlyOwned : boolean;
  public conversionFlag : Common.conversionFlags; //コンバージョンフラグ  
  public signupTimestamp: Date; //サインアップ日時
  public lastAccessDate: Date; //最終アクセス日
  public isTenantAdmin : boolean = false;
  public urlPermissions : Common.BindItem[];
  public hasScannerLicense :boolean = false;
  public mfaEnabled:boolean = false; 
  public trialExpiry : Date = null;
  public paidEntryUser : boolean = true;
  public paidStartDate : Date = null;
  public hasApproveLicense: boolean = false;
  public safeIntroductionPackExpiry: Date = null;   // あんしん導入パック有効期限
  public isPrime: boolean = false;
  public isSupport: boolean = false;  
  public isIntroduction: boolean = false; // 紹介案件
}


export class ListViewMenuQuery extends Query {
  constructor(){
    super("ListViewMenuQuery",new Common.ModelBinder(ListViewMenuResult,false));
  }
  public viewName:string = '';
}

export class ListViewMenuResult extends ObjectBase {
    constructor(){
      super('ListViewMenuResult');
      this.binders.fileLayouts = new Common.ModelBinder(Common.FileLayout,true);
      this.binders.reportTemplates = new Common.ModelBinder(Common.ReportTemplate,true);      
    }  
    public fileLayouts : Array<Common.FileLayout>;
    public reportTemplates : Array<Common.ReportTemplate>;
}


export class RowSequenceUpdateQuery extends Query {
  constructor(instance : ObjectBase, targetSeq: number){
    super("RowSequenceUpdateQuery!" + instance.className, instance.binder); //ジェネリック型としてサーバーに転送。レスポンスバインダは不要
    this.instance = instance;
    this.targetSeq = targetSeq;
  }
  public instance : ObjectBase;
  public targetSeq  :number;
}

export class RowSequenceCountQuery extends Query {
  constructor(instance : ObjectBase){
    super("RowSequenceCountQuery!" + instance.className,null); //ジェネリック型としてサーバーに転送。レスポンスバインダは不要
    this.instance = instance;
  }
  public instance : ObjectBase;
}

export class HasProvisioningDataQuery extends Query {
  constructor(auditNoList : Common.BindItem[]){
    super("HasProvisioningDataQuery",null); //ジェネリック型としてサーバーに転送。レスポンスバインダは不要.
    this.auditNoList = auditNoList;
  }
  public auditNoList : Common.BindItem[];  
}

export class HelpContent extends ObjectBase {
    constructor(){
      super('HelpContent');
    }
    public id:string;
    public title:string;
    public description:string;
    public body:string;
    public collection: string;
    public score:number;    
    public prioritized:boolean;
    public pageview:number;
}
export class HelpContentItemQuery extends Query {
  constructor(id:string){
    super("HelpContentItemQuery",new Common.ModelBinder(HelpContent, false)); //ジェネリック型としてサーバーに転送。レスポンスバインダは不要.
    this.id = id;
  }
  public id : string; 
}
export class HelpContentListQuery extends Query {
  constructor(tag:string){
    super("HelpContentListQuery",new Common.ModelBinder(HelpContent, true)); //ジェネリック型としてサーバーに転送。レスポンスバインダは不要.
    this.tag = tag;
  }
  public tag : string; 
}
export class HelpContentQuery extends LoadQuery {
  constructor(){
    super("HelpContentQuery", HelpContent); //ジェネリック型としてサーバーに転送。レスポンスバインダは不要.

  }
  public id : string; 
  public tag : string; 
  public collection:string;
  public title:string;
}

export class VoucherImportQuery extends Query {
  constructor(queryName:string, ctor : new ()=>ObjectBase){
    super(queryName,new Common.ModelBinder(ctor, true));
  }
  public targetSheet:string;
}